// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2fo8R","dragIcon":"SortableItem_dragIcon__1fZVB","disabled":"SortableItem_disabled__2Ns8z"};